var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component, ElementRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractComponent } from 'gp-admin-abstract';
var SwitchButtonComponent = /** @class */ (function (_super) {
    __extends(SwitchButtonComponent, _super);
    function SwitchButtonComponent(el) {
        var _this = _super.call(this, el) || this;
        _this.el = el;
        /**
         * Текст внутри кнопки
         *
         * @type {string}
         */
        _this.text = '';
        /**
         * Чекед или нет
         *
         * @type {boolean}
         */
        _this.checked = false;
        /**
         * Состояние доступности компонента
         *
         * @type {boolean}
         */
        _this.disabled = false;
        _this.propagateChange = function (_) {
        };
        return _this;
    }
    SwitchButtonComponent.prototype.toggleClass = function () {
        this.checked = !this.checked;
        this.propagateChange(this.checked);
    };
    SwitchButtonComponent.prototype.writeValue = function (value) {
        this.checked = value;
    };
    SwitchButtonComponent.prototype.registerOnChange = function (fn) {
        this.propagateChange = fn;
    };
    SwitchButtonComponent.prototype.registerOnTouched = function (fn) {
    };
    SwitchButtonComponent.prototype.setDisabledState = function (isDisabled) {
        this.disabled = isDisabled;
    };
    SwitchButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 'gp-switch-button',
                    template: "\n<button\n  ngDefaultControl\n  class=\"gp-switch-button {{extraClass}}\"\n  [ngClass]=\"[\n    !!state ? 'gp-switch-button--'+state : '',\n    !!size ? 'gp-switch-button--'+size : '',\n    disabled ? 'gp-switch-button--disabled' : '',\n    checked ? 'gp-switch-button--active' : ''\n  ]\"\n  (click)=\"toggleClass()\"\n  [disabled]=\"disabled\"\n>{{text}}</button>\n\n<!-- success / error / warning / grey / white / small -->\n",
                    styles: [
                        "@charset \"UTF-8\";\n/**\n * \u041F\u0435\u0440\u0435\u043C\u0435\u043D\u043D\u044B\u0435\n */\n:root {\n  --color-white: white;\n  --color-success: #00afec;\n  --color-warning: #ffb827;\n  --color-error: #f35252;\n  --color-disabled: #dbdbdb;\n  --color-black: black;\n  --color-span: #b5b5b5;\n  --color-span-second: #212121;\n  --color-bg: #f8f8f8;\n  --color-bg-second: #f8f8f8;\n  --color-bg-success: rgba(0, 175, 236, 0.1);\n  --color-bg-warning: var(--color-warning);\n  --color-bg-error: var(--color-error);\n  --color-placeholder: #b5b5b5;\n  --color-border: #dbdbdb;\n  --color-radio-border: #d3d3d3;\n  --font-roboto: 'Roboto', sans-serif;\n  --font-helvetica: 'Helvetica', sans-serif; }\n\n/**\n *\n */\n/**\n * \u0421\u0442\u0438\u043B\u0438 \u0434\u043B\u044F \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u0430 \"gp-switch-button\"\n */\n.gp-switch-button {\n  font: bold 1.4rem/1.6rem \"Roboto\", sans-serif;\n  position: relative;\n  padding: 1rem 3rem 0.9rem;\n  cursor: pointer;\n  -moz-transition: all 100ms ease;\n  -o-transition: all 100ms ease;\n  -webkit-transition: all 100ms ease;\n  transition: all 100ms ease;\n  text-align: center;\n  border: 0.1rem solid rgba(0, 0, 0, 0.01);\n  border-radius: 0.2rem; }\n  .gp-switch-button:after {\n    position: absolute;\n    top: 0.2rem;\n    right: 0.2rem;\n    bottom: 0.2rem;\n    left: 0.2rem;\n    display: block;\n    width: 1.3rem;\n    margin-right: calc(100% - 1.7rem);\n    content: '';\n    -moz-transition: all 300ms ease;\n    -o-transition: all 300ms ease;\n    -webkit-transition: all 300ms ease;\n    transition: all 300ms ease;\n    border-radius: 0.1rem;\n    background-color: var(--color-white);\n    box-shadow: 0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.15); }\n  .gp-switch-button:active:after, .gp-switch-button--active:after {\n    margin-left: calc(100% - 1.7rem);\n    border-color: rgba(0, 0, 0, 0.1); }\n  .gp-switch-button:disabled, .gp-switch-button--disabled {\n    cursor: not-allowed;\n    background-color: #f8f8f8; }\n  .gp-switch-button--small {\n    padding: 0.7rem 2.5rem; }\n  .gp-switch-button--success {\n    background-color: var(--color-bg-success);\n    color: #00afec; }\n    .gp-switch-button--success:active, .gp-switch-button--success.gp-switch-button--active {\n      background-color: #00afec;\n      color: var(--color-white); }\n  .gp-switch-button--error {\n    background-color: rgba(243, 82, 82, 0.1);\n    color: #f35252; }\n    .gp-switch-button--error:active, .gp-switch-button--error.gp-switch-button--active {\n      background-color: #f35252;\n      color: var(--color-white); }\n  .gp-switch-button--warning {\n    background-color: rgba(255, 184, 39, 0.1);\n    color: #ffb827; }\n    .gp-switch-button--warning:active, .gp-switch-button--warning.gp-switch-button--active {\n      background-color: #ffb827;\n      color: var(--color-white); }\n  .gp-switch-button--grey {\n    background-color: #f8f8f8; }\n    .gp-switch-button--grey:active, .gp-switch-button--grey.gp-switch-button--active {\n      background-color: #f0f0f0; }\n  .gp-switch-button--white {\n    border-color: #f0f0f0;\n    background-color: var(--color-white); }\n    .gp-switch-button--white:disabled {\n      color: #b5b5b5; }\n"
                    ],
                    providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: SwitchButtonComponent,
                            multi: true
                        }
                    ]
                },] },
    ];
    /** @nocollapse */
    SwitchButtonComponent.ctorParameters = function () { return [
        { type: ElementRef, },
    ]; };
    SwitchButtonComponent.propDecorators = {
        'text': [{ type: Input },],
        'state': [{ type: Input },],
        'size': [{ type: Input },],
        'checked': [{ type: Input },],
        'disabled': [{ type: Input },],
    };
    return SwitchButtonComponent;
}(AbstractComponent));
export { SwitchButtonComponent };
//# sourceMappingURL=switch-button.component.js.map